// Centralised TidyCal config — change this URL in one place.
export const TIDYCAL_URL = "https://tidycal.com/shinrai/entretien-decouverte";
// Embed URL (works for iframe)
export const TIDYCAL_EMBED_URL = TIDYCAL_URL;
